import React from 'react';
import SiteHeader from './SiteHeader';
import PageFooter from './PageFooter';
import PageMeta from './PageMeta';
import PageHero from './PageHero';
import { pageContent } from './pageContent';

function PageLayout({
  pageKey,
  heroVisual,
  children,
}) {
  const page = pageContent[pageKey];

  if (!page) {
    throw new Error(`Unknown pageKey: ${pageKey}`);
  }

  return (
    <div id="root">
      <PageMeta title={page.title} description={page.description} />
      <SiteHeader />
      {page.hero ? <PageHero hero={page.hero} visual={heroVisual} /> : null}
      {children}
      <PageFooter
        title={page.footerTitle}
        text={page.footerText}
        primaryLabel={page.footerPrimaryLabel}
        primaryHref={page.footerPrimaryHref}
        secondaryLabel={page.footerSecondaryLabel}
        secondaryHref={page.footerSecondaryHref}
        secondaryExternal={page.footerSecondaryExternal}
      />
    </div>
  );
}

export default PageLayout;